'use strict';

require('./delete.revoked.tokens.modal.css');

/* @ngInject */
export default class DeleteRevokedTokensModalController {
	public $scope: any;
	public $uibModalInstance: any;
	public okFunction: any;
	public name: any;
	public color: any;

  constructor($scope, $uibModalInstance, okFunction) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.okFunction = okFunction;

  }

  ok() {
    this.$uibModalInstance.close();
    this.okFunction(this.name, this.color);
  };

  cancel() {
    this.$uibModalInstance.close();
  };
}
